const HTML_TAG_REGEX = /(<([^>]+)>)/gi

export const removeTags = (str = '') =>
  str.toString().replace(HTML_TAG_REGEX, '')
